// extracted by mini-css-extract-plugin
module.exports = {"work":"WorkTeam_work__Ol6OI","headerwork":"WorkTeam_headerwork__3k0sw","cardtext":"WorkTeam_cardtext__OaTBw"};